export default __webpack_public_path__ + "static/installers-placeholder-ea10b408881de48221d5e2449b3b4b1b.png";